import { useNavigate } from '@reach/router';
import instance from 'api';
import Button from 'components/button/Button';
import { endpoints } from 'endpoints.config';
import { Toast } from 'helpers/toast';
import { useDispatch } from 'react-redux';
import { getCustomerComponentResources } from 'reducers/componentResources';
import { CardSubPage } from './CardPage';
import { useState } from 'react';
import { Spinner } from 'components/spinner/Spinner';

export const DeactivateCard = ({ cardId }: { cardId: number }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const handleDeactivate = () => {
        setLoading(true);
        instance
            .post(endpoints.cards.deactivateCard, { topUpCardsId: cardId })
            .then((res) => {
                setLoading(false);
                Toast.openSuccessToast('Your card has been deactivated successfully');
                dispatch(getCustomerComponentResources());
                navigate(`../${cardId}/${CardSubPage.TRANSACTIONS}`);
            }) // TODO add success message
            .catch((err) => {
                setLoading(false);
                Toast.openGenericErrorToast();
            });
        }
        return (
            <div className="DectivateCardPage FormPage">
                <p className="WarningText">
                    Deactivating this card will void any attempted transactions. You can undo this
                    action
                </p>
                <Button variety="full" disabled={loading} onClick={handleDeactivate}>
                    {loading ? <Spinner insideButton={true} size={20} color="#fff" /> : ' Deactivate Card'}
                </Button>
            </div>
        );
    }
